import { defineComponent as _defineComponent } from 'vue'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { MetaPhoneNumber } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsAppMetaPhoneActivationDialog',
  props: {
    phone: { type: [Object, null], required: true },
    isSubmitting: { type: Boolean, required: true }
  },
  emits: ["close", "confirm"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const { t } = useI18n();

const emit = __emit;

const pin = ref('');
const isValid = computed(() => /^\d{6}$/.test(pin.value));

watch(
    () => props.phone,
    () => {
        pin.value = '';
    },
);

const close = () => {
    if (props.isSubmitting) return;
    pin.value = '';
    emit('close');
};

const submit = () => {
    if (!isValid.value || props.isSubmitting) return;
    emit('confirm', pin.value);
};

const __returned__ = { props, t, emit, pin, isValid, close, submit, get Dialog() { return Dialog }, get DialogPanel() { return DialogPanel }, get DialogTitle() { return DialogTitle }, get TransitionChild() { return TransitionChild }, get TransitionRoot() { return TransitionRoot } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})